import React, { FC, SVGProps } from "react";

export const IconBuy: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.38892 1.66699C10.9235 1.66705 12.1662 2.90974 12.1663 4.44434H13.5559C14.3195 4.44457 14.9444 5.06945 14.9446 5.83301V10.2783H14.3889C12.088 10.2786 10.2219 12.1443 10.2219 14.4453C10.222 14.8299 10.2757 15.2021 10.3733 15.5557H5.22192C4.45822 15.5555 3.83339 14.9307 3.83325 14.167V5.83301C3.83347 5.06938 4.45827 4.44445 5.22192 4.44434H6.6106C6.6107 2.9097 7.85426 1.66699 9.38892 1.66699ZM6.6106 7.22266C6.61079 7.60444 6.92408 7.91699 7.30591 7.91699C7.68754 7.91676 8.00005 7.6043 8.00024 7.22266V5.83301H6.6106V7.22266ZM10.7776 7.22266C10.7778 7.60437 11.0902 7.91687 11.4719 7.91699C11.8538 7.91699 12.1661 7.60444 12.1663 7.22266V5.83301H10.7776V7.22266ZM9.38892 3.05566C8.62509 3.05566 8.00035 3.68053 8.00024 4.44434H10.7776C10.7775 3.68057 10.1527 3.05572 9.38892 3.05566Z"
        fill="currentColor"
      />
      <path
        d="M15.5338 12.778L15.5338 15.3586L16.359 14.6571L16.4201 14.6107C16.7331 14.395 17.1647 14.4475 17.4162 14.7433C17.6842 15.059 17.6462 15.5323 17.3307 15.8005L15.2694 17.551L15.1587 17.6291C14.8885 17.7854 14.5428 17.7591 14.2977 17.551L12.2363 15.8005L12.7222 15.2292L13.2072 14.6571L14.0332 15.3586L14.0332 12.778C14.0332 12.3638 14.3693 12.0277 14.7835 12.0277C15.1977 12.0277 15.5338 12.3638 15.5338 12.778ZM12.2363 15.8005C11.9208 15.5323 11.8821 15.059 12.1501 14.7433C12.4181 14.4277 12.8915 14.3892 13.2072 14.6571L12.2363 15.8005Z"
        fill="currentColor"
      />
    </svg>
  );
};
